import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { nextStepCredStepper } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const faqsAction = async (action, _datastore, { navigate, goBack }) => {
    navigate(ROUTE.FAQ);
};
export const goBackAction = async (action, _datastore, { navigate, goBack }) => {
    await goBack();
};
export const needHelpAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const createNewApplication = async (action, _datastore, { network, instrumentTrack, navigate }) => {
    instrumentTrack("CREATE_NEW_APPLICATION_DSP");
    let accountId = action?.payload?.accountId;
    // make api call to create new application
    const response = await network.get(`${api.bookTransfer}/${accountId}`, {
        headers: await getAppHeader(),
        // let network layer handle the error
    });
    // on success first set application id in async storage navigate to step got from api response
    if (response.status === 200) {
        const newDspApplicationId = response.data.applicationId;
        await AsyncStorage.setItem('application_id', newDspApplicationId);
        const currentStepId = response.data.currentStepId;
        const routeObj = await nextStepCredStepper(currentStepId);
        await navigate(routeObj.routeId, routeObj.params);
    }
};
